module.exports = __webpack_public_path__ + "a153655125d563adca5b0e0b5da8d8a6.mp3";